export const MANAGER_STEP3_TEXT = {
  sectionStep: '03',
  sectionTitle: 'Попередньо згенерований документ',
  sectionDescription: 'Перегляньте сформовану заяву перед наступним етапом опрацювання.',
  openButton: 'Відкрити PDF в новій вкладці',
  previewTitle: 'Попередньо згенерований документ',
  submitButton: 'Надіслати на підписання клієнту',
  submitSuccessMessage: 'Заявку успішно надіслано на підписання клієнту',
  successCloseButton: 'Закрити',
} as const;

export const MANAGER_STEP3_ACCESS_DENIED_TEXT = 'У вас немає прав доступу до кроку УДБТФ.';

export const MANAGER_STEP3_LOADING_TEXT = 'Завантажуємо документ...';
export const MANAGER_STEP3_MISSING_PDF_TEXT = 'Не вдалося завантажити PDF документ';
